import { AccountCircle } from '@mui/icons-material';
import { Avatar } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { apiPost } from 'cdx-common';
import React from 'react';
import { useApi } from '../api';
import { useSession } from '../libraries/SessionProvider';
import { useUploadManager } from '../libraries/UploadManager';
import { FileLoader } from './AppItems';

export const LeftTopMenu = () => {

    const { user } = useSession();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const isMenuOpen = Boolean(anchorEl);
    const { handleBackendResponse } = useApi();
    const { openUploadDialog } = useUploadManager();
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    //const navigate = useNavigate();

    const menuId = 'account-menu';
    const handleLogout = async () => {
        const response = await apiPost('logout', {});
        handleBackendResponse(response);
        document.location.href = '/';
    };

    const handleUploadsOpen = () => {
        handleMenuClose();
        openUploadDialog();
    };

    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={menuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            <MenuItem onClick={handleUploadsOpen}>Téléchargements</MenuItem>
            <MenuItem onClick={handleLogout}>Déconnexion</MenuItem>
        </Menu>
    );

    return <div>
        <MenuItem
            aria-label="Ouvrir les options du compte"
            onClick={handleProfileMenuOpen}
            sx={{ minHeight: 40, px: { xs: 0.75, sm: 2 } }}
        >
            {user?.imageFileId ? <FileLoader id={String(user.imageFileId)} render={file => <Avatar alt={user.name} src={file.thumbUrl ?? file.url} />} /> : <AccountCircle />}
        </MenuItem>
        {renderMenu}
    </div>;
};
